import React, { useEffect, useState, Fragment } from "react";
import styled from "@emotion/styled";

import { useParams } from "react-router";
import { useSelector } from "react-redux";
import db from "../firebase";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  Spinner,
  Button,
  Heading,
  Box,
  Image,
  useToast,
  Avatar,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";
import {
  StarIcon,
  CalendarIcon,
  SunIcon,
  EditIcon,
  RepeatIcon,
} from "@chakra-ui/icons";

function CardDetails() {
  const { id } = useParams();
  const toast = useToast();

  const [property, setProperty] = useState();
  const [owner, setOwner] = useState();
  const [booked, setBooked] = useState(false);
  const user = useSelector((state) => state.user.userId);

  useEffect(() => {
    window.scrollTo(0, 0);
    db.collection("properties")
      .doc(id)
      .get()
      .then((doc) => {
        let propertyFetched = doc.data();
        setProperty(propertyFetched);
        db.collection("users")
          .doc(propertyFetched.userId)
          .get()
          .then((doc) => {
            setOwner(doc.data());
          });
      });
  }, []);

  const checkHouse = () => {
    if (!user) {
      toast({
        title: "Authentication required",
        description: "Please sign in before making a reservation.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (property.available) {
      db.collection("properties")
        .doc(id)
        .update({
          available: false,
        })
        .then(() => {
          toast({
            title: "Congratulation!",
            description:
              "You just reserved the property, the owner will contact you for more details!",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          window.scrollTo(0, 0);
          setBooked(true);
        })
        .catch((error) => {});
    } else {
      toast({
        title: "Oh no  !",
        description: "The property is currently not available.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Fragment>
      {!property && (
        <LoadingDiv>
          <Spinner color="red.500" size="xl" thickness="4px" speed="0.65s" />
        </LoadingDiv>
      )}
      {!booked ? (
        <MainDiv>
          {property && (
            <Fragment>
              <TitleDiv>
                <Heading as="h3" size="lg">
                  {property.description} hosted by
                </Heading>
                <FirstDescription>
                  <div>
                    <StarIcon color="#EE575D" h={3} />
                    <span>{property.rating}</span>
                  </div>

                  <p>
                    ({property.reviews}) · {property.location}{" "}
                  </p>
                </FirstDescription>
                <ImageDiv>
                  <Image src={property.images[0]} />
                  <ImageGrid>
                    <Image src={property.images[1]} />
                    <Image src={property.images[2]} />
                    <Image src={property.images[3]} />
                    <Image src={property.images[4]} />
                  </ImageGrid>
                </ImageDiv>
              </TitleDiv>
              <SingleDescription>
                <Heading as="h3" size="md">
                  {property.subdescription} by {!owner ? "" : owner.name}
                </Heading>
                <OwnerDiv>
                  <p>
                    {property.guests} guest(s), · {property.bedrooms}{" "}
                    bedroom(s), · {property.bathroom} bathroom(s), ·{" "}
                    {property.beds} bed(s)
                  </p>
                  <Avatar src="data:image/png;base64,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" />
                </OwnerDiv>

                <MidDescription>
                  <Options>
                    <hr />
                    <div>
                      <EditIcon />
                      <div>
                        <span>
                          Entire Home
                          <br />
                          <p>You’ll have the entire property to yourself.</p>
                        </span>
                      </div>
                    </div>
                    <div>
                      <SunIcon />
                      <div>
                        <span>
                          Enhanced Clean
                          <br />
                          <p>
                            This host committed to Airbnb's 5-step enhanced
                            cleaning process.
                          </p>
                        </span>
                      </div>
                    </div>
                    <div>
                      <RepeatIcon />
                      <div>
                        <span>
                          Self check-in
                          <br />
                          <p>Check yourself in with the keypad.</p>
                        </span>
                      </div>
                    </div>
                    <div>
                      <CalendarIcon />
                      <div>
                        <span>Free cancellation before Sep 28</span>
                      </div>
                    </div>
                    <hr />
                  </Options>
                  <Checkout
                    borderWidth="1px"
                    borderRadius="lg"
                    overflow="hidden"
                  >
                    <p>
                      <div>
                        <Heading as="h2" size="md" isTruncated>
                          $ {property.price} / night
                        </Heading>
                      </div>
                      <div>
                        <StarIcon color="#EE575D" h={3} />
                        <span>
                          {property.rating} ({property.reviews} reviews)
                        </span>
                      </div>
                    </p>
                    <hr />
                    <h3>· {property.guests} guest(s)</h3>
                    <h3>· {property.bedrooms} bedroom(s)</h3>
                    <h3>· {property.beds} bed(s)</h3>
                    <h3>· {property.bathroom} bath(s)</h3>
                    <Button
                      color="white"
                      bgColor="#EE575D"
                      _hover={{ color: "#EE575D", bgColor: "#EDF2F7" }}
                      onClick={checkHouse}
                    >
                      {property.available ? "Reserve" : "Check availability"}
                    </Button>
                    
                    <p>
                      Good price.Your dates are {property.price - 45} $Entire
                      condominium (condo) hosted by Meredith less than the
                      average nightly rate over the last 3 months.
                    </p>
                  </Checkout>
                </MidDescription>
              </SingleDescription>
            </Fragment>
          )}
        </MainDiv>
      ) : (
        <SuccessDiv>
          <Alert
            status="success"
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            height="200px"
          >
            <AlertIcon boxSize="40px" mr={0} />
            <AlertTitle mt={4} mb={1} fontSize="lg">
              Property booked!
            </AlertTitle>
            <AlertDescription maxWidth="sm">
              Thanks for booking the property. The owner will get back to you
              soon.
            </AlertDescription>
          </Alert>
        </SuccessDiv>
      )}
    </Fragment>
  );
}

export default CardDetails;

const MainDiv = styled.div`
  margin-top: 80px;
  @media (min-width: 1000px) {
    padding: 50px 120px;
  }
  padding: 50px 30px;
`;

const SuccessDiv = styled.div`
  margin-top: 80px;
  padding: 150px;
`;

const TitleDiv = styled.div`
  h3 {
    margin-bottom: 12px;
  }
  div {
    display: flex;
    align-items: center;

    span {
      margin-right: 7px;
    }
  }
`;

const ImageDiv = styled.div`
  margin: 35px 0px;
  padding: 10px;
  width: 80vw;
  img {
    width: 400px;
    margin: 10px;
    border-radius: 7px;
  }

  @media (max-width: 1100px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;

  img {
    width: 250px;
  }

  @media (max-width: 1100px) {
    flex-direction: column;
    img {
      width: 400px;
    }
  }
`;

const SingleDescription = styled.div`
  hr {
    margin: 25px 0px;
  }
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    span {
      margin-left: 15px;
      font-weight: bold;

      p {
        color: gray;
        font-weight: 400;
      }
    }
  }
`;
const MidDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const Checkout = styled(Box)`
  width: 400px;

  padding: 20px;
  p {
    display: flex;
    justify-content: space-between;
  }

  h3 {
    margin-top: 15px;
  }

  button {
    width: 100%;
    margin: 20px 0px;
  }
`;

const FirstDescription = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 400px) {
    flex-direction: column;
  }
`;

const LoadingDiv = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OwnerDiv = styled.div`
  display: flex;
  align-items: center;

  p {
    margin-right: 150px;
  }
`;
